import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

export type SvgIconConfig = {
  brand:
    | 'lit-hotslots'
    | 'lit-homercasino'
    | 'lit-energiekasino'
    | 'lit-energycasino'
    | 'lit-januszcasino'
    | 'lit-kingspin'
    | 'lit-tikalcasino';
  hostUrl: string;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SVG_ICON_CONFIG: DiToken<SvgIconConfig> = new DiToken<SvgIconConfig>('SvgIconConfig');

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SVG_ICON_DOMAIN_NUMBER_STR: DiToken<string> = new DiToken<string>('svgIconDomainNumberStr');
